import { apiCMSWithToken } from './axios'
import { apiLandingCMSWithToken } from './axiosLanding'
import axios from 'axios'

export const apiPublicNoAuth = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/landing/v1/public`,
  withCredentials: false,
  timeout: 20000,
  headers: {
    'content-type': 'application/json; charset=utf-8'
  }
})

// Response interceptor to extract data
apiPublicNoAuth.interceptors.response.use(
  (response) => {
    if (response && response.data) {
      return response.data
    }
    return response
  },
  (error) => {
    return Promise.reject(error)
  }
)

export const url = {
  selection: '/selection-list'
}
export async function getListSelection(p = {}) {
  try {
    const params = new URLSearchParams({ ...p })
    const response = await apiCMSWithToken.get(
      `${url.selection}?${params.toString()}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function createSelection(body) {
  const response = await apiCMSWithToken.post(
    `${url.selection}/create-selection`,
    body
  )
  return response
}

export async function updateSelection(body, id) {
  const response = await apiCMSWithToken.put(`${url.selection}/${id}`, body)
  return response
}

export async function deleteSelection(id, body) {
  const response = await apiCMSWithToken.delete(`${url.selection}/${id}`, {
    ...body
  })
  return response
}

export async function getListCategory(p = {}) {
  try {
    const params = new URLSearchParams({ ...p })
    const response = await apiCMSWithToken.get(
      `${url.selection}/category?${params.toString()}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function getAllSelections(p = {}) {
  const params = new URLSearchParams({ ...p })

  try {
    const response = await apiCMSWithToken.get(
      `${url.selection}/all?${params.toString()}`
    )
    return response
  } catch (error) {
    console.error('Error in getAllSelections:', error)
    throw error
  }
}

export async function getListSelectionByCategories(category) {
  try {
    const response = await apiLandingCMSWithToken.get(
      `/public/selection-list/find-by-categories?categories=${category}`
    )
    return response
  } catch (error) {
    console.error('Error in getListSelectionByCategory:', error)
    throw error
  }
}

export async function getPostDateOptions() {
  try {
    const response = await apiCMSWithToken.get(
      `/selection-list/find-by-categories`,
      {
        params: {
          categories: 'POST_DAY'
        }
      }
    )
    return response
  } catch (error) {
    console.error('Error fetching post date options:', error)
    throw error
  }
}
export async function getAllSelectionsList() {
  try {
    const response = await apiPublicNoAuth.get(
      `${process.env.REACT_APP_API_URL}/jv-api/landing/public/selection-list/find-all`
    )
    const payload = response?.data

    if (Array.isArray(payload)) {
      return payload
    }

    if (Array.isArray(payload?.data)) {
      return payload.data
    }

    if (Array.isArray(response)) {
      return response
    }

    return []
  } catch (error) {
    console.error('Error in getListSelectionByCategory:', error)
    throw error
  }
}
